import React from "react";
import { Navigate } from "react-router-dom";
import { isLoggedin } from "@/utils/auth";

type Props = { children: React.ReactNode };

export default function ProtectedRoute({ children }: Props ) {
    if (!isLoggedin()) {
        return <Navigate to="/login" replace />
    }
    return <>{children}</>;
}